@if ({ allClientData: clientData$() | async }; as $) {
  <p-dialog
    [visible]="assignKeyFobModal()"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [closeOnEscape]="true"
    (onHide)="closeDialogEvent()"
    [breakpoints]="{ '991px': '100vw' }"
    [style]="{ width: '700px' }"
    styleClass="no-header-modal"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div
        class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        @if (allClientData) {
          <div class="flex align-items-center">
            <h2 class="mb-0 text-sm">
              {{ 'CLIENT_PROFILE.KYE_FOB.ASSIGN_KEY_FOB_FOR' | translate }}
              <strong>{{ $.allClientData.full_name }} </strong>
              <span class="text-xs text-600"> - {{ $.allClientData.id }}</span>
            </h2>
          </div>
        }
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closeDialogEvent()"
        ></div>
      </div>
      <!-- Header -->
      <!-- Content -->
      <div class="flex">
        <!-- Left Side-->
        <div
          class="border-right-1 border-300 lg:w-8 w-full surface-100 flex flex-column justify-content-between"
        >
          <form
            [formGroup]="assignKeyFobFormGroup"
            (ngSubmit)="postAssignKeyFob()"
          >
            <!-- Modal Content -->
            <div class="py-3 md:py-5 px-3 md:px-5">
              @if ($.allClientData && $.allClientData.current_keyfob) {
                <div class="mb-4 text-sm">
                  <label
                    class="font-medium text-700 text-xs mb-2 block uppercase"
                    >{{
                      'CLIENT_PROFILE.KYE_FOB.CURRENT_KEYFOB_NUMBER' | translate
                    }}</label
                  >
                  <strong class="text-sm">{{
                    $.allClientData.current_keyfob
                  }}</strong>
                </div>
              }
              <label class="font-medium text-700 text-xs mb-2 block uppercase">
                @if (!$.allClientData?.current_keyfob) {
                  <span>{{
                    'CLIENT_PROFILE.KYE_FOB.ENTER_KEY_FOB_FOR' | translate
                  }}</span>
                }
                @if ($.allClientData?.current_keyfob) {
                  <span>{{
                    'CLIENT_PROFILE.KYE_FOB.CHANGE_KEY_FOB_NUMBER' | translate
                  }}</span>
                }
              </label>
              <input
                type="text"
                class="w-full text-sm"
                pInputText
                formControlName="keyFobNumber"
                aria-label="keyfob-number-input"
              />
              <!-- Validation feedback -->
              @if (isValidatingKeyfob) {
                <div class="flex align-items-center mt-2 text-sm text-600">
                  <i class="pi pi-spin pi-spinner mr-2"></i>
                  <span>Validating keyfob...</span>
                </div>
              }
              @if (
                !isValidatingKeyfob &&
                keyfobValidationMessage &&
                keyFobNumber.value &&
                keyFobNumber.value !== $.allClientData?.current_keyfob
              ) {
                <div
                  [ngClass]="{
                    'text-green-600': isKeyfobValid,
                    'text-red-600': !isKeyfobValid,
                  }"
                  class="flex align-items-center mt-2 text-sm"
                >
                  <i
                    [ngClass]="{
                      'pi pi-check-circle': isKeyfobValid,
                      'pi pi-times-circle': !isKeyfobValid,
                    }"
                    class="mr-2"
                  ></i>
                  <span>{{ keyfobValidationMessage }}</span>
                </div>
              }
              @if (keyFobNumber.dirty && keyFobNumber.invalid) {
                <app-error-msg
                  [errors]="keyFobNumber.errors"
                  [fieldLabel]="'ASSIGN_KEY_FOB.KEYFOB_NUMBER' | translate"
                />
              }
            </div>
            <!-- Modal Content -->
            <!-- Modal Footer -->
            <div class="lg:px-4 px-2 py-3 border-top-1 border-400 surface-0">
              <div class="flex align-items-center justify-content-between">
                <div class="w-4">
                  @if ($.allClientData?.current_keyfob) {
                    <p-button
                      type="button"
                      [label]="'CLIENT_PROFILE.KYE_FOB.DELETE' | translate"
                      icon="pi pi-trash"
                      styleClass="p-button-danger text-sm"
                      (click)="deleteKeyFob()"
                      [loading]="btnLoading"
                      aria-label="delete-keyfob-button"
                    />
                  }
                </div>
                <div
                  class="w-8 text-right flex align-items-center justify-content-end gap-2"
                >
                  <p-button
                    type="button"
                    [label]="'CLIENT_PROFILE.KYE_FOB.CANCEL' | translate"
                    styleClass="p-button-link text-sm"
                    (click)="closeDialogEvent()"
                    aria-label="cancel-keyfob-button"
                  />
                  <button
                    type="submit"
                    class="text-sm"
                    pButton
                    pRipple
                    [loading]="btnLoading"
                    [disabled]="!canSubmitForm"
                    [label]="'CLIENT_PROFILE.KYE_FOB.ASSIGN' | translate"
                    aria-label="assign-keyfob-submit-button"
                  ></button>
                </div>
              </div>
            </div>
            <!-- Modal Footer -->
          </form>
        </div>
        <!-- Left Side -->
        <!-- Right Side -->
        <div
          class="pl-3 w-4 hidden lg:flex align-items-center justify-content-center p-3 text-right"
        >
          <img
            width="160"
            src="/assets/img/assign-keyFOB-img.svg"
            alt="Image"
          />
        </div>
        <!-- Right Side -->
      </div>
      <!-- Content -->
    </ng-template>
  </p-dialog>
}
